import api from '../../request/request'

const createEntryOrder = (teamId, entryOrder) => {
    return api.postPromise('entryOrder/createEntryOrder',
        { teamId }, entryOrder)
}

const createWholeEntryOrder = (teamId, entryOrderDto) => {
    return api.postPromise('entryOrder/createWholeEntryOrder',
        { teamId }, entryOrderDto)
}

const addEntryOrderItems = (groupId, items) => {
    return api.postPromise('entryOrder/addEntryOrderItems',
        { groupId }, items)
}

const findEntryOrders = (query) => {
    return api.postPromise('entryOrder/findEntryOrders', {}, query, null, true)
}

const editEntryOrder = (entryOrder) => {
    return api.postPromise('entryOrder/editEntryOrder', {}, entryOrder)
}

const suspend = (groupId) => {
    return api.getPromise('entryOrder/suspend', {groupId})
}

const editEntryOrderItems = (groupId, action, items) => {
    return api.postPromise('entryOrder/editEntryOrderItems',
        { groupId, action }, items)
}

export default {
    createEntryOrder,
    createWholeEntryOrder,
    addEntryOrderItems,
    findEntryOrders,
    editEntryOrder,
    suspend,
    editEntryOrderItems
}



// WEBPACK FOOTER //
// ./src/request/newSys/entryOrderApi.js